<template>
  <v-row class="ma-0" id="professionalCategory">
    <v-col class="pa-0" cols="12">
      <v-card  class="ma-0 ma-2 pa-0 pb-2" color="transparent" flat v-if="!isSubCategory">
        <v-row class="ma-0">
          <v-col class="pa-0" cols="4">
            <v-btn v-if="!isSubCategory"
                   @click="$emit('close')"
                   class="secondary">
              <span>{{ $translate('BACK') }}</span>
          </v-btn>
          </v-col>
          <v-col class="pa-0">
            <span class="text-h5 font-italic font-weight-medium "
                  v-if="!isSubCategory"> {{ category.Name}}
          </span>
          </v-col>
        </v-row>
        <v-row>
        <h3 class="px-4 pt-4" v-if="category.SubCategories"> {{ $translate('CATEGORIES') }}</h3>
        </v-row>
      </v-card>

      <section :class="!isSubCategory? 'sticky-header' : ''">
        <template v-for="(product, index) in category.Products" >
          <ProfessionalViewProduct :item="product" :key="index" @getShoppingLists="getShoppingLists">
          </ProfessionalViewProduct>
        </template>

        <template v-for="(cat, subIndex) in category.SubCategories" id="subCategory">
          <ProfessionalViewSubCategory :subCategory="cat" />
<!--          <v-expansion-panels-->
<!--            class="pa-0 ma-0 mb-2"-->
<!--            multiple-->
<!--          >-->
<!--            <v-expansion-panel-->
<!--              :key="`subCategory-${subIndex}`"-->
<!--              class="pa-0 ma-0"-->
<!--            >-->
<!--              <v-expansion-panel-header-->
<!--                class="expansion-panel-header"-->
<!--                v-slot="{ open }"-->
<!--                expand-icon=""-->
<!--              >-->
<!--                <v-list class="wrap-text ma-0 pa-0">-->
<!--                  <v-list-item :key="`list-${subIndex}`" class="pa-0 pr-md-1">-->
<!--                    <v-list-item-avatar>-->
<!--                      <v-img-->
<!--                        max-width="50"-->
<!--                        max-height="50"-->
<!--                        :src="-->
<!--                                cat.PictureUrl != null-->
<!--                                  ? cat.PictureUrl-->
<!--                                  : cat.Picture-->
<!--                              "-->
<!--                      />-->
<!--                    </v-list-item-avatar>-->
<!--                    <v-list-item-content>-->
<!--                      <v-list-item-title-->
<!--                        v-text="cat.Name"-->
<!--                        class="homepageSubTitle"-->
<!--                      >-->
<!--                      </v-list-item-title>-->
<!--                      <v-list-item-subtitle v-if="!isMobile">-->
<!--                              <span-->
<!--                                v-html="cat.Description"-->
<!--                                class="primary&#45;&#45;text text-wrap text-body-1"-->
<!--                              ></span>-->
<!--                      </v-list-item-subtitle>-->
<!--                      <v-list-item-subtitle-->
<!--                        v-if="-->
<!--                                getCounterForCategory(cat.Id) > 0 &&-->
<!--                                orders.length > 0-->
<!--                              "-->
<!--                      ><span class="font-weight-bold text&#45;&#45;primary">-->
<!--                                {{ getCounterForCategory(cat.Id) }}-->
<!--                                {{ $translate('SELECTED') }}-->
<!--                              </span>-->
<!--                      </v-list-item-subtitle>-->
<!--                    </v-list-item-content>-->
<!--                    <v-list-item-action>-->
<!--                      <v-btn-->
<!--                        small-->
<!--                        color="secondary"-->
<!--                        class="pa-0 pa-2 secondary-font-color"-->
<!--                      ><span v-if="!open"-->
<!--                      >{{ $translate('OPEN_CATEGORY') }}-->
<!--                              </span>-->
<!--                        <span v-else-->
<!--                        >{{ $translate('CLOSE_CATEGORY') }}-->
<!--                              </span></v-btn-->
<!--                      >-->
<!--                    </v-list-item-action>-->
<!--                  </v-list-item></v-list-->
<!--                >-->
<!--              </v-expansion-panel-header>-->
<!--              <v-expansion-panel-content class="px-1 ma-0">-->
<!--                <template v-for="(product, index) in cat.Products">-->
<!--                  <h1>{{ 'hello product'}}</h1>-->
<!--                  <ProfessionalViewProduct :item="product" :key="index">-->
<!--                  </ProfessionalViewProduct>-->
<!--                </template>-->
<!--                <template v-for="(subCategory, index) in cat.SubCategories" v-if="cat.SubCategories.length > 0">-->

<!--                <ProfessionalViewCategory :items="subCategory"-->
<!--                                          :subCategory="true">-->
<!--                </ProfessionalViewCategory>-->
<!--                </template>-->
<!--              </v-expansion-panel-content>-->
<!--            </v-expansion-panel>-->
<!--          </v-expansion-panels>-->
        </template>

<!--        <div v-for="(cat,subIndex)  in category.SubCategories" v-if="!openSubCategory" class="pa-0 ma-0" :key="`subCategory-${subIndex}`">-->
<!--          <v-card class="pa-0 px-2">-->
<!--            <v-list class="wrap-text ma-0 pa-0">-->
<!--              <v-list-item  class="pa-0 pr-md-1" @click="viewSubCategory(cat)">-->
<!--                <v-list-item-avatar>-->
<!--                  <v-img-->
<!--                    max-width="50"-->
<!--                    max-height="50"-->
<!--                    :src="-->
<!--                      cat.PictureUrl != null-->
<!--                        ? cat.PictureUrl-->
<!--                        : cat.Picture-->
<!--                    "-->
<!--                  />-->
<!--                </v-list-item-avatar>-->
<!--                <v-list-item-content>-->
<!--                  <v-list-item-title-->
<!--                    v-text="cat.Name"-->
<!--                    class="homepageSubTitle"-->
<!--                  >-->
<!--                  </v-list-item-title>-->
<!--                  <v-list-item-subtitle v-if="!isMobile">-->
<!--                    <span-->
<!--                      v-html="cat.Description"-->
<!--                      class="primary&#45;&#45;text text-wrap text-body-1"-->
<!--                    ></span>-->
<!--                  </v-list-item-subtitle>-->
<!--                </v-list-item-content>-->
<!--                <v-list-item-action>-->
<!--                  <v-btn-->
<!--                    small-->
<!--                    color="secondary"-->
<!--                    class="pa-0 pa-2 secondary-font-color"-->
<!--                  > {{ $translate('OPEN_CATEGORY') }} </v-btn>-->
<!--                </v-list-item-action>-->
<!--              </v-list-item></v-list>-->
<!--          </v-card>-->
<!--        </div>-->
<!--        <ProfessionalViewCategory v-if="openSubCategory"-->
<!--                                  :items="subCategoryObj"-->
<!--                                  :subCategory="true"-->
<!--                                  @close="closeOpenedCategory()"/>-->

      </section>
    </v-col>
  </v-row>
</template>

<script>
import ProfessionalViewProduct from "@/components/event/professionalViewType/ProfessionalViewProduct.vue";
import { scrollToElement } from '@/shared/utility';
import {mapState} from "vuex";
import {cloneDeep} from "lodash";
import ProfessionalViewSubCategory from "@/components/event/professionalViewType/ProfessionalViewSubCategory.vue";

export default {
  name: 'ProfessionalViewCategory',
  components: {ProfessionalViewSubCategory, ProfessionalViewProduct},
  props: {
    items : Object,
    isSubCategory: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      category: this.items,
      categoryId: 0,
      count: [],
      productsInCategoryCount: [],
      shoppingCart: [],
      productsInCart: [],

      openSubCategory: false,
      subCategoryObj: {},
    }
  },
  mounted() {
    this.scrollToCategory();
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    ...mapState('shoppingCart', {
      orders: (state) => state.orders,
    }),
  },
  methods: {
    initOrders() {
      this.shoppingCart = [];
      if (this.orders.length > 0) {
        this.shoppingCart = cloneDeep(this.orders);
      } else {
        this.productsInCart = [];
      }
      if (this.shoppingCart.length > 0) {
        this.productsInCart = [];
        //this.productsInCart = this.shoppingCart[0].Products;
        this.shoppingCart.forEach((item) => {
          this.productsInCart.push(item.Products);
        });
        this.getProductCountInEachCategory();
      }
    },

    getCounterForCategory(categoryId) {
      let quantity = 0;

      if (this.productsInCategoryCount.length < 0)
        this.getProductCountInEachCategory();

      for (let i = 0; i < this.productsInCategoryCount.length; i++) {
        let obj = this.productsInCategoryCount[i];
        if (obj.categoryId === categoryId) {
          quantity += obj.quantity;
        }
      }
      return quantity;
    },

    getProductCountInEachCategory() {
      this.productsInCategoryCount = [];
      if (this.productsInCart.length > 0) {
        this.allCategories.forEach((category) => {
          category.Products.forEach((product) => {
            this.productsInCart.forEach((cartProduct) => {
              cartProduct.forEach((item) => {
                if (item.ProductId === product.Id) {
                  let tempProduct = {
                    categoryId: 0,
                    quantity: 0,
                  };

                  tempProduct.categoryId = category.Id;
                  if (item.ProductType !== 'Weighted') {
                    tempProduct.quantity += Number(item.Quantity);
                  } else {
                    tempProduct.quantity += 1;
                  }
                  this.productsInCategoryCount.push(tempProduct);
                }
              });
            });
          });
        });
      }
    },

    scrollToCategory() {
      if(!this.isSubCategory)
      scrollToElement('#professionalCategory');
      else {
        scrollToElement('#subCategory');
      }
    },

    viewSubCategory(subCat) {
      this.openSubCategory = true;
      this.subCategoryObj = subCat;
    },

    getShoppingLists(){
      this.$emit('getShoppingLists');
    },
    
    closeOpenedCategory() {},
  }
}
</script>

<style scoped lang="scss">
.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
  padding: 0px !important;
}
.expansion-panel-header {
  padding: 8px 8px 8px !important;
}
.wrap-text {
  //white-space: nowrap;
  white-space: normal;
  overflow-x: hidden;
  text-overflow: ellipsis;
}
.sticky-header {
  //overflow: hidden;
 // overflow-y: scroll;
 // max-height: 700px
}
</style>
